import { createMenuCmdField, EntityManagerConfig } from '../models/entity-config';
import { RendicontazioneRoutes } from '../modules/rendicontazione/rendicontazione.app-manager-routes';

export class RendicontazioneEMC extends EntityManagerConfig {
  override initFields(): void {
    this.cmdFields = [createMenuCmdField(RendicontazioneRoutes.RendicontazioneRapportinoList)];
  }
}
